import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState } from '../../controller';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { NavigateToNextPage } from '../navigateToNextPage/navigateToNextPage';
import {
  isSlotLocked,
  isSlotWithOpenWaitingList,
} from '../../../../utils/slotAvailability/slotAvailability';
import { TimeSlot } from '@wix/ambassador-bookings-availability-v2-time-slot/types';

export type OnSlotSelected = (selectedSlotsIds: number[]) => void;

export function createOnSlotSelectedAction(
  actionFactoryParams: ActionFactoryParams<CalendarState, CalendarContext>,
  navigateToNextPage: NavigateToNextPage,
): OnSlotSelected {
  return async (selectedSlotsIds) => {
    const { getControllerState } = actionFactoryParams;
    const [state, setState] = getControllerState();
    const { availableSlots } = state;

    const selectedSlotId = selectedSlotsIds[0];
    const selectedSlot: TimeSlot = availableSlots!.timeSlots![selectedSlotId];

    const isWaitingListFlow =
      isSlotWithOpenWaitingList(selectedSlot) || isSlotLocked(selectedSlot);

    setState(
      {
        selectableSlotsAtSelectedTime: [selectedSlot],
        selectedTime: selectedSlot.localStartDate!,
      },
      { immediate: true },
    );

    await navigateToNextPage({
      selectedSlots: [selectedSlot],
      isWaitingListFlow,
    });
  };
}
